import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

// eslint-disable-next-line import/prefer-default-export
export const sendListsSlice = createSlice({
  name: "sendLists",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setSendLists: (state, action) => action.payload,
    addSendList: (state, action) => {
      if (!state.find((sl) => sl.uuid === action.payload.uuid)) {
        state.push(action.payload);
      }
    },
  },
});

export const { setSendLists, addSendList } = sendListsSlice.actions;

export default sendListsSlice.reducer;

export const selectSendLists = (state) => state.sendLists;
export const selectSendListByUUID = (uuid) => (state) =>
  state.sendLists.find((sl) => sl.uuid === uuid);
